import { Spinner } from './styles';

const SpinnerComponent: React.FC<{ size?: number; testid?: string }> = ({
  size,
  testid
}) => <Spinner $size={size} data-testid={testid ?? 'spinner'} />;

export default SpinnerComponent;
